export default __webpack_public_path__ + "static/media/1029.c85c738c.svg";